import React, { useEffect } from "react";
import "./CustomerStories.css";
import b1 from "../../assets/customer brands/Ericsson.webp";
import b2 from "../../assets/customer brands/fybros.webp";
import b3 from "../../assets/customer brands/MI.webp";
import b4 from "../../assets/customer brands/Motorola sol.webp";
import b5 from "../../assets/customer brands/oppo.webp";
import b6 from "../../assets/customer brands/pepsico.webp";
import b7 from "../../assets/customer brands/reckitt.webp";
import b8 from "../../assets/customer brands/S_C_Johnson.webp";
import b9 from "../../assets/customer brands/Star.webp";
import b10 from "../../assets/customer brands/vivo.webp";
import b11 from "../../assets/customer brands/Amazon.webp";


const logos = [b1, b2, b3, b4, b5, b6, b7, b8, b9,b10,b11];

const CustomerStories = () => {
  useEffect(() => {
    const duplicateScroll = (id) => {
      const track = document.getElementById(id);
      if (track && !track.dataset.duplicated) {
        track.innerHTML += track.innerHTML;
        track.dataset.duplicated = "true";
      }
    };

    duplicateScroll("track1");
    duplicateScroll("track2");
  }, []);

  return (
    <>
      <h1 className="customerheading">Trusted By These Brands</h1>

      <div className="customer-stories-wrapper">
        <div className="logo-strip">
          <div className="logo-track scroll-ltr" id="track1">
            {logos.map((img, i) => (
              <img key={`row1-${i}`} src={img} alt={`Customer ${i + 1}`} />
            ))}
          </div>
        </div>

        <div className="logo-strip">
          <div className="logo-track scroll-rtl" id="track2">
            {logos.map((img, i) => (
              <img key={`row2-${i}`} src={img} alt={`Customer ${i + 1}`} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerStories;
